
import { RevSkeleton } from '@ds/components/Skeleton'

const NB_LINES_COMMENT = 6

export default {
  components: {
    RevSkeleton,
  },
  computed: {
    commentLines: () => Array.from(Array(NB_LINES_COMMENT)),
  },
}
